module.exports = __webpack_public_path__ + "img/sacha_pf.ab8b849d.jpg";